import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FiMail, FiPhone, FiMapPin, FiLinkedin, FiGithub } from "react-icons/fi";
import { personalInfo } from "../data/personalInfo";
import "./Contact.css";

const Contact = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section id="contact" className="contact section" ref={ref}>
      <div className="container">
        <motion.div
          className="section__header"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <span className="section__label">Get In Touch</span>
          <h2 className="section__title">Let's Work Together</h2>
          <p className="section__subtitle">
            I'm open to freelance and full-time opportunities.
          </p>
        </motion.div>

        <motion.div
          className="contact__cards"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <a href={`mailto:${personalInfo.email}`} className="contact__card">
            <div className="contact__card-icon">
              <FiMail size={22} />
            </div>
            <strong>Email</strong>
            <span>{personalInfo.email}</span>
          </a>

          <a href={`tel:${personalInfo.phone}`} className="contact__card">
            <div className="contact__card-icon">
              <FiPhone size={22} />
            </div>
            <strong>Phone</strong>
            <span>{personalInfo.phone}</span>
          </a>

          <div className="contact__card">
            <div className="contact__card-icon">
              <FiMapPin size={22} />
            </div>
            <strong>Location</strong>
            <span>{personalInfo.location}</span>
          </div>

          <a
            href={personalInfo.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="contact__card"
          >
            <div className="contact__card-icon">
              <FiLinkedin size={22} />
            </div>
            <strong>LinkedIn</strong>
            <span>View Profile</span>
          </a>
        </motion.div>

        <motion.div
          className="contact__socials"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <a
            href={personalInfo.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="contact__social-link"
            aria-label="LinkedIn"
          >
            <FiLinkedin size={20} />
          </a>
          <a
            href={personalInfo.github}
            target="_blank"
            rel="noopener noreferrer"
            className="contact__social-link"
            aria-label="GitHub"
          >
            <FiGithub size={20} />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
